import { c as _c } from "react/compiler-runtime";
import useSuspenseQuery from 'commons/useSuspenseQuery';
import cleanObjectFromEmptyValues from 'commons/cleanObjectFromEmptyValues';
import { ALL_CUSTOMER_PHOTOS_AND_REVIEWS } from '../queries';
const useProductCustomerPhotosReviews = (id, t0) => {
  const $ = _c(15);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  let t2;
  if ($[2] !== id) {
    t2 = cleanObjectFromEmptyValues({
      id
    });
    $[2] = id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = !id;
  const t4 = options.ssr ?? true;
  let t5;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
    t5 = {
      variables: t2,
      skip: t3,
      ssr: t4
    };
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const {
    loading,
    error,
    data
  } = useSuspenseQuery(ALL_CUSTOMER_PHOTOS_AND_REVIEWS, t5);
  const t6 = data?.allCustomerPhotosAndReviews?.reviews;
  const t7 = data?.allCustomerPhotosAndReviews?.customer_photos;
  let t8;
  if ($[8] !== t6 || $[9] !== t7) {
    t8 = {
      customerReviews: t6,
      customerPhotos: t7
    };
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== error || $[12] !== loading || $[13] !== t8) {
    t9 = {
      loading,
      error,
      data: t8
    };
    $[11] = error;
    $[12] = loading;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
};
export default useProductCustomerPhotosReviews;